import {
  Dispatch,
  SetStateAction,
} from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from 'react-bootstrap';
import {
  MDPData,
  PDPMatchData,
  MatchAction,
  ActionData,
} from '../types/mdp.types';
import PDPMatchRow from './PDPMatchRow';

type MDPMatchTableProp = {
  displayName?: boolean,
  filteredPDPs: PDPMatchData[],
  pdpMatches: PDPMatchData[],
  setPDPMatches: Dispatch<SetStateAction<PDPMatchData[]>>,
  setActionData: Dispatch<SetStateAction<ActionData>>,
  mdp: MDPData,
  matchActionOptions: MatchAction[],
  setShowConfirmSubmit: Dispatch<SetStateAction<boolean>>,
  setShowNotifyCall: Dispatch<SetStateAction<boolean>>,
  setShowMDPNotes: Dispatch<SetStateAction<boolean>>,
  setSelectedMatch: Dispatch<SetStateAction<PDPMatchData | undefined>>,
  state: string,
}

function MDPMatchTable({
  displayName,
  filteredPDPs,
  pdpMatches,
  setPDPMatches,
  setActionData,
  mdp,
  matchActionOptions,
  setShowConfirmSubmit,
  setShowNotifyCall,
  setSelectedMatch,
  setShowMDPNotes,
  state,
}: MDPMatchTableProp): JSX.Element {
  const { t } = useTranslation();

  return (
    <Table responsive hover className="mb-3 linktable">
      <thead>
        <tr className="linktableheader">
          <th>
            #
          </th>
          {displayName ? (
            <th className="col-2">
              {`${t('PDP_ID')} - ${t('Name')}`}
            </th>
          ) : (
            <th className="col-1">
              {t('PDP_ID')}
            </th>
          )}
          <th className="col-1 nowrap">
            {t('Date_Match')}
          </th>
          <th className="col-2">
            {(state !== 'not considered' && state !== 'not considered by prebytery') ? (
              t('ExperienceLevel')
            ) : (
              ''
            )}
          </th>
          <th className="col-2">
            {t('Status')}
          </th>
          <th className="col-1">
            {t('CS')}
          </th>
          <th className="col-4">
            {t('Match_Action')}
          </th>
        </tr>
      </thead>
      <tbody>
        {filteredPDPs?.map((match: PDPMatchData, index: number) => (
          <PDPMatchRow
            index={index + 1}
            displayCallSeekerName={displayName}
            key={`recent-matches-${match.id}`}
            match={match}
            pdpMatches={pdpMatches}
            setPDPMatches={setPDPMatches}
            setActionData={setActionData}
            mdp={mdp}
            matchActionOptions={matchActionOptions}
            setShowConfirmSubmit={setShowConfirmSubmit}
            setShowNotifyCall={setShowNotifyCall}
            setSelectedMatch={setSelectedMatch}
            setShowMDPNotes={setShowMDPNotes}
            state={state}
          />
        ))}
      </tbody>
    </Table>
  );
}

MDPMatchTable.defaultProps = {
  displayName: false,
};

export default MDPMatchTable;
